import store from '@/store';
import Lockr from 'lockr';
import axios from 'axios';

var cache = {
  /**
   * 载入全部登陆信息
   */
  loadingCache: function loadingCache() {
    if (Lockr.get('Admin-Token') && !axios.defaults.headers['Admin-Token']) {
      /** 将用户信息放入缓存 */
      var userInfo = Lockr.get('loginUserInfo');
      if (userInfo) {
        store.commit('SET_USERINFO', userInfo);
      }
      //权限相关
      //const authList = Lockr.get('authList')
      // if (authList) {
      // }
    }
  },
  /**
   * 请求和更新登录缓存 设置请求头为缓存中的token 并且获取用户信息
   */
  updateAxiosCache: function updateAxiosCache() {
    axios.defaults.headers['Admin-Token'] = Lockr.get('Admin-Token');
    store.dispatch("GetUserInfo");
  },
  /**
   * 移除登录信息
   * @param {*}  
   */
  rmAxiosCache: function rmAxiosCache() {
    Lockr.rm('Admin-Token');
  }
};

export default cache;